import inputEventBus from '@/mixins/input-eventbus';

export default {
    inserted: function(el) {
        inputEventBus.$emit('hiddenInputInit', el.value, el.id, el);
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/hidden-input.js